module.exports = __webpack_public_path__ + "img/desktop-application-development.2b1e5941.png";